/*
  DiginamiX refresh, stage one (October 2026).
  Sticky bars on phones: the Build Your Christmas total with its next-step button,
  and the product page price with its add to basket button. Also the product page
  photo carousel and "Read more" for long product descriptions.
  Both bars mirror existing buttons and labels, so no text lives here, and a tap on
  the bar simply clicks the original button. Remove this file from layout/theme.liquid to undo.
*/
(function () {
  var phone = window.matchMedia('(max-width: 980px)');
  var visibleBars = 0;

  function setBarVisible(bar, visible) {
    if (bar.classList.contains('is-visible') === visible) return;
    bar.classList.toggle('is-visible', visible);
    visibleBars += visible ? 1 : -1;
    document.body.classList.toggle('dx-bar-visible', visibleBars > 0);
    window.dispatchEvent(new CustomEvent('dx:bars'));
  }

  function createBar(labelText, amountText, buttonText) {
    var bar = document.createElement('div');
    bar.className = 'dx-sticky';
    bar.innerHTML =
      '<div class="dx-sticky__info"><span class="dx-sticky__label"></span><span class="dx-sticky__amount"></span></div>' +
      '<button type="button" class="dx-sticky__button"></button>';
    bar.querySelector('.dx-sticky__label').textContent = labelText;
    bar.querySelector('.dx-sticky__amount').textContent = amountText;
    bar.querySelector('.dx-sticky__button').textContent = buttonText;
    document.body.appendChild(bar);
    return bar;
  }

  function mirrorText(source, target) {
    if (!source || !target) return;
    var update = function () { target.textContent = source.textContent.trim(); };
    update();
    new MutationObserver(update).observe(source, { childList: true, characterData: true, subtree: true });
  }

  // Show the bar only while the original button is off screen.
  // The builder passes allWidths: its order summary (with the original button) is hidden
  // during the steps, so the bar carries the total and the next button on desktop too.
  function showWhenOffScreen(bar, original, allWidths) {
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setBarVisible(bar, (allWidths || phone.matches) && !entry.isIntersecting);
      });
    }).observe(original);
    if (allWidths) return;
    phone.addEventListener('change', function () { if (!phone.matches) setBarVisible(bar, false); });
  }

  function builderBar() {
    var root = document.querySelector('[data-preorder-builder]');
    if (!root) return;
    var action = root.querySelector('[data-builder-primary-action]');
    var total = root.querySelector('[data-builder-total]');
    var totalLabel = total && total.parentElement ? total.parentElement.querySelector('span') : null;
    if (!action || !total) return;

    var bar = createBar(totalLabel ? totalLabel.textContent.trim() : '', total.textContent.trim(), action.textContent.trim());
    bar.classList.add('dx-sticky--builder');
    mirrorText(total, bar.querySelector('.dx-sticky__amount'));
    mirrorText(action, bar.querySelector('.dx-sticky__button'));
    bar.querySelector('.dx-sticky__button').addEventListener('click', function () { action.click(); });
    showWhenOffScreen(bar, action, true);
  }

  function productBar() {
    var form = document.querySelector('.pdp__form');
    if (!form) return;
    var add = form.querySelector('[data-add-to-cart]');
    var price = document.querySelector('.pdp__price [data-variant-price]');
    var title = document.querySelector('.pdp__title');
    if (!add || !price) return;

    var bar = createBar(title ? title.textContent.trim() : '', price.textContent.trim(), add.textContent.trim());
    bar.classList.add('dx-sticky--product');
    mirrorText(price, bar.querySelector('.dx-sticky__amount'));
    mirrorText(add, bar.querySelector('.dx-sticky__button'));
    var button = bar.querySelector('.dx-sticky__button');
    button.addEventListener('click', function () { add.click(); });
    var syncDisabled = function () { button.disabled = add.disabled; };
    syncDisabled();
    new MutationObserver(syncDisabled).observe(add, { attributes: true, attributeFilter: ['disabled'] });
    showWhenOffScreen(bar, add);
  }

  // On phones the WhatsApp button sits just above the Shopify Inbox chat button,
  // wherever Inbox places it (its position can change with Inbox settings).
  function stackWhatsApp() {
    var whatsapp = document.querySelector('.whatsapp-fab');
    if (!whatsapp) return;
    var place = function () {
      if (!window.matchMedia('(max-width: 767px)').matches) { whatsapp.style.removeProperty('bottom'); return; }
      var host = document.querySelector('shopify-chat');
      var bubble = host && host.shadowRoot ? host.shadowRoot.querySelector('.activator-nudge, button') : null;
      var rect = bubble ? bubble.getBoundingClientRect() : null;
      if (!rect || !rect.height) return;
      whatsapp.style.setProperty('bottom', Math.round(window.innerHeight - rect.top + 10) + 'px', 'important');
    };
    [500, 2000, 5000].forEach(function (delay) { setTimeout(place, delay); });
    window.addEventListener('resize', place);
    // The chat button moves with the sticky bars, so follow it once the move has finished.
    window.addEventListener('dx:bars', function () { setTimeout(place, 260); });
  }

  // Product page carousel (phones and desktop): swipe, arrows, arrow keys, a progress bar and a counter,
  // and on desktop a row of thumbnails instead of the progress bar.
  // Tapping a photo opens the theme's own full-screen gallery at that photo.
  function productCarousel() {
    var gallery = document.querySelector('[data-dx-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-dx-gallery-track]');
    var slides = track.children;
    var bar = gallery.querySelector('[data-dx-gallery-bar]');
    var count = gallery.querySelector('[data-dx-gallery-count]');
    var total = slides.length;
    var current = 0;
    var strip = gallery.querySelector('[data-dx-gallery-thumbs]');
    var thumbs = strip ? strip.querySelectorAll('[data-dx-gallery-thumb]') : [];
    var shown = 0;

    // Desktop thumbnail row: mark the current photo and keep its thumbnail in the middle of the row.
    function syncThumbs() {
      if (!thumbs.length || current === shown) return;
      thumbs[shown].classList.remove('is-active');
      thumbs[shown].removeAttribute('aria-current');
      shown = current;
      var thumb = thumbs[current];
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');
      if (strip.offsetParent) {
        strip.scrollTo({ left: thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2, behavior: 'smooth' });
      }
    }

    function update() {
      var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      current = Math.max(0, Math.min(total - 1, index));
      bar.style.width = ((current + 1) / total * 100) + '%';
      count.textContent = (current + 1) + ' / ' + total;
      gallery.classList.toggle('is-first', current === 0);
      gallery.classList.toggle('is-last', current === total - 1);
      syncThumbs();
    }
    function go(index) {
      track.scrollTo({ left: Math.max(0, Math.min(total - 1, index)) * track.clientWidth, behavior: 'smooth' });
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    gallery.querySelector('[data-dx-gallery-prev]').addEventListener('click', function () { go(current - 1); });
    gallery.querySelector('[data-dx-gallery-next]').addEventListener('click', function () { go(current + 1); });
    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () { go(Number(thumb.getAttribute('data-dx-gallery-thumb'))); });
    });
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); go(current + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(current - 1); }
    });
    track.addEventListener('click', function (event) {
      var image = event.target.closest('[data-dx-gallery-index]');
      if (!image) return;
      var thumb = document.querySelectorAll('[data-product-gallery] [data-thumb]')[Number(image.getAttribute('data-dx-gallery-index'))];
      var opener = document.querySelector('[data-product-gallery] [data-gallery-open]');
      if (thumb) thumb.click();
      if (opener) opener.click();
    });
    update();
  }

  // Contact page: the showroom map only loads Google Maps after the visitor clicks "Show map".
  function venueMap() {
    var box = document.querySelector('[data-dx-venue-map]');
    if (!box) return;
    var button = box.querySelector('[data-dx-venue-map-load]');
    button.addEventListener('click', function () {
      var frame = document.createElement('iframe');
      frame.src = box.getAttribute('data-src');
      frame.title = box.getAttribute('aria-label');
      frame.loading = 'lazy';
      frame.referrerPolicy = 'no-referrer-when-downgrade';
      frame.setAttribute('allowfullscreen', '');
      box.appendChild(frame);
      box.classList.add('is-loaded');
    });
  }

  // Long product descriptions show the first lines with "Read more", so the price and
  // "Add to basket" are not pushed far down. The full text is unchanged and one tap away.
  function readMore() {
    var desc = document.querySelector('.pdp__desc[data-dx-read-more]');
    if (!desc) return;
    var limit = window.matchMedia('(max-width: 767px)').matches ? 190 : 240;
    if (desc.scrollHeight <= limit + 60) return;
    desc.classList.add('dx-clamp');
    desc.style.setProperty('--dx-clamp', limit + 'px');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'dx-read-more';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = desc.getAttribute('data-dx-read-more');
    desc.insertAdjacentElement('afterend', button);
    button.addEventListener('click', function () {
      var open = desc.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.textContent = desc.getAttribute(open ? 'data-dx-read-less' : 'data-dx-read-more');
      if (!open) desc.scrollIntoView({ block: 'nearest' });
    });
  }

  /* Growave star line under the product title: on a product without reviews it read "No reviews"
     with five empty stars. With data-dx-hide-empty-stars on the placeholder, the stars, "No reviews"
     and the divider are hidden once Growave reports 0 ratings; "Ask a question" stays. The widget
     lives in Growave's open shadow root, so the rule is added there; it waits up to 20 seconds. */
  function emptyStars() {
    var placeholders = document.querySelectorAll('.gw-rv-star-rating-widget-placeholder[data-dx-hide-empty-stars]');
    if (!placeholders.length) return;
    var rule = '.gw-rv-star-rating-widget:has(.gw-rv-rating-stars[aria-label^="0 "]) > .gw-tooltip__trigger,' +
      '.gw-rv-star-rating-widget:has(.gw-rv-rating-stars[aria-label^="0 "]) > .gw-rv-star-rating-widget__divider{display:none!important}';
    var tries = 0;
    var timer = setInterval(function () {
      var pending = 0;
      placeholders.forEach(function (placeholder) {
        var root = placeholder.shadowRoot;
        if (!root) { pending++; return; }
        if (root.querySelector('style[data-dx-empty-stars]')) return;
        var style = document.createElement('style');
        style.setAttribute('data-dx-empty-stars', '');
        style.textContent = rule;
        root.appendChild(style);
      });
      if (!pending || ++tries > 40) clearInterval(timer);
    }, 500);
  }

  function init() {
    builderBar();
    productBar();
    stackWhatsApp();
    productCarousel();
    venueMap();
    readMore();
    emptyStars();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
